export default "__VITE_ASSET__5nDA3drP__"